module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "hiui_fade"
    },
    on: {
      "after-leave": _vm.afterLeave
    }
  }, [(_vm.show) ? _c('div', {
    class: _vm.component_class
  }, [(_vm.show_icon) ? _c('Icon', {
    attrs: {
      "name": _vm.iconType[_vm.type],
      "size": 16
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "hiui-toast-content"
  }, [_vm._v(_vm._s(_vm.content))])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-27d0c3c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toast/Toast.vue
// module id = 626
// module chunks = 0